"use strict";

import React from "react";
import Wprr from "wprr";
import Dbm from "dbm";

export default class GeneralQuoteForm extends Wprr.BaseObject {
	
	/**
	 * Constructor
	 */
	_construct() {
		
		super._construct();

		this._elementTreeItem.setValue("uiState", "edit");
		
		let form = this._elementTreeItem.addNode("form", new Wprr.utils.data.multitypeitems.controllers.form.Form());
		
		{
			let currentField = form.createField("name", "").getType("controller");
			currentField.addNotEmptyValidation();
		}
		
		{
			let currentField = form.createField("email", "").getType("controller");
			currentField.addEmailValidation();
		}

		{
			let currentField = form.createField("phoneNumber", "").getType("controller");
			currentField.addNotEmptyValidation();
		}
		
		{
			let currentField = form.createField("message", "").getType("controller");
			currentField.addNotEmptyValidation();
		}
	}

	_save() {
		let project = this.getFirstInput(Wprr.sourceReference("wprr/project"));
		
		let fields = Wprr.objectPath(this._elementTreeItem, "form.linkedItem.controller").getValues();
		let loader = project.getActionLoader("submitForm?form=generalQuote", fields);
		
		let uiStateReSource = this._elementTreeItem.getType("uiState").reSource();
		loader.addSuccessCommand(Wprr.commands.setProperty(uiStateReSource, "value", "sent"));
		loader.addSuccessCommand(Wprr.commands.callFunction(this, this._saved));
		
		loader.addErrorCommand(Wprr.commands.alert("An error occured"));
		loader.addErrorCommand(Wprr.commands.setProperty(uiStateReSource, "value", "edit"));
		
		this._elementTreeItem.setValue("uiState", "sending");
		
		loader.load();
	}
	
	_saved() {
		Dbm.repository.getControllerIfExists("trackingController").trackEvent("quoteRequested");
	}
	
	
	_renderMainElement() {
		
		let mobileLayout = <div className="centered-content-text">
			<Wprr.layout.form.LabelledArea label={Wprr.sourceTranslation("Name", "name.title")}>
				<Wprr.FormField className="full-width standard-field standard-field-padding" value={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.fields.name.value")} placeholder="Enter your name..." />
			</Wprr.layout.form.LabelledArea>
			<div className="spacing medium" />
			<Wprr.layout.form.LabelledArea label={Wprr.sourceTranslation("Email", "email.title")}>
				<Wprr.FormField className="full-width standard-field standard-field-padding" value={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.fields.email.value")} placeholder="you@email.com"/>
			</Wprr.layout.form.LabelledArea>
			<div className="spacing medium" />
			<Wprr.layout.form.LabelledArea label={Wprr.sourceTranslation("Phone number", "phoneNumber.title")}>
				<Wprr.FormField className="full-width standard-field standard-field-padding" value={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.fields.phoneNumber.value")} placeholder="+44 0000 000000"/>
			</Wprr.layout.form.LabelledArea>
			<div className="spacing medium" />
			<Wprr.layout.form.LabelledArea label={Wprr.sourceTranslation("Message", "message.title")}>
				<Wprr.FormField className="full-width standard-field standard-field-padding" value={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.fields.message.value")} placeholder="What size of storage are you looking for and when?" />
			</Wprr.layout.form.LabelledArea>
			<div className="spacing medium" />
				<Wprr.SelectSection selectedSections={this._elementTreeItem.getType("uiState")}>
					<div data-section-name="sending">
						<div className="standard-button standard-button-padding inactive-during-process">
							<Wprr.FlexRow className="micro-item-spacing justify-center">
								{Wprr.idText("Sending", "site.sending")}
								<Wprr.Image src="loader-white.svg" className="image background-contain small-loader" />
							</Wprr.FlexRow>
						</div>
					</div>
					<div data-section-name="sent">
						<div className="standard-button standard-button-padding inactive-during-process text-align-center">
							{Wprr.idText("Sent", "site.sent")}
						</div>	
					</div>
					<div data-default-section={true}>
						<Wprr.HasData check={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.isValid")}>
							<Wprr.layout.interaction.Button commands={Wprr.commands.callFunction(this, this._save)} className="standard-button standard-button-padding text-align-center" text={Wprr.sourceTranslation("Request a quote", "site.requestAQuote")} />
						</Wprr.HasData>
						<Wprr.HasData check={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.isValid")} checkType="invert/default">
							<Wprr.layout.interaction.Button commands={Wprr.commands.callFunction(Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.controller"), "validate")} className="inactive-button standard-button-padding text-align-center" text={Wprr.sourceTranslation("Request a quote", "site.requestAQuote")} />
						</Wprr.HasData>
					</div>
				</Wprr.SelectSection>
		</div>;
		

		let desktopLayout = <div className="centered-content-text">
			<Wprr.layout.form.LabelledArea label={Wprr.sourceTranslation("Name", "name.title")}>
				<Wprr.FormField className="full-width standard-field standard-field-padding" value={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.fields.name.value")} placeholder="Enter your name..." />
			</Wprr.layout.form.LabelledArea>
			<div className="spacing medium" />
			<Wprr.layout.form.LabelledArea label={Wprr.sourceTranslation("Email", "email.title")}>
				<Wprr.FormField className="full-width standard-field standard-field-padding" value={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.fields.email.value")} placeholder="you@email.com"/>
			</Wprr.layout.form.LabelledArea>
			<div className="spacing medium" />
			<Wprr.layout.form.LabelledArea label={Wprr.sourceTranslation("Phone number", "phoneNumber.title")}>
				<Wprr.FormField className="full-width standard-field standard-field-padding" value={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.fields.phoneNumber.value")} placeholder="+44 0000 000000"/>
			</Wprr.layout.form.LabelledArea>
			<div className="spacing medium" />
			<Wprr.layout.form.LabelledArea label={Wprr.sourceTranslation("Message", "message.title")}>
				<Wprr.FormField className="full-width standard-field standard-field-padding" value={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.fields.message.value")} placeholder="What size of storage are you looking for and when?" />
			</Wprr.layout.form.LabelledArea>
			<div className="spacing medium" />
			<Wprr.FlexRow className="justify-center">
				<Wprr.SelectSection selectedSections={this._elementTreeItem.getType("uiState")}>
					<div data-section-name="sending">
						<div className="standard-button standard-button-padding inactive-during-process">
							<Wprr.FlexRow className="micro-item-spacing">
								{Wprr.idText("Sending", "site.sending")}
								<Wprr.Image src="loader-white.svg" className="image background-contain small-loader" />
							</Wprr.FlexRow>
						</div>
					</div>
					<div data-section-name="sent">
						<div className="standard-button standard-button-padding inactive-during-process">
							{Wprr.idText("Sent", "site.sent")}
						</div>	
					</div>
					<div data-default-section={true}>
						<Wprr.HasData check={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.isValid")}>
							<Wprr.layout.interaction.Button commands={Wprr.commands.callFunction(this, this._save)} className="standard-button standard-button-padding" text={Wprr.sourceTranslation("Request a quote", "site.requestAQuote")} />
						</Wprr.HasData>
						<Wprr.HasData check={Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.isValid")} checkType="invert/default">
							<Wprr.layout.interaction.Button commands={Wprr.commands.callFunction(Wprr.sourceStatic(this._elementTreeItem, "form.linkedItem.controller"), "validate")} className="inactive-button standard-button-padding" text={Wprr.sourceTranslation("Request a quote", "site.requestAQuote")} />
						</Wprr.HasData>
					</div>
				</Wprr.SelectSection>			
			</Wprr.FlexRow>
		</div>;

		let responsiveLayout = Wprr.creators.responsiveTemplate(mobileLayout);
		responsiveLayout.addResponsiveTemplate(desktopLayout, 400);

		return <React.Fragment>
			{responsiveLayout.getReactElements()}
		</React.Fragment>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return <Wprr.layout.admin.WpBlockEditor dataSettings={dataSettings}>
			<div>

			</div>
		</Wprr.layout.admin.WpBlockEditor>;
	}
}